module.exports = __webpack_public_path__ + "static/img/ent-detail-45.88b52d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-45.jpg
// module id = NDb0
// module chunks = 52